import { render, staticRenderFns } from "./VideoAudienceAnalysisModule.vue?vue&type=template&id=785d2306&scoped=true"
import script from "./VideoAudienceAnalysisModule.vue?vue&type=script&lang=js"
export * from "./VideoAudienceAnalysisModule.vue?vue&type=script&lang=js"
import style0 from "./VideoAudienceAnalysisModule.vue?vue&type=style&index=0&id=785d2306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d2306",
  null
  
)

export default component.exports